import { render, staticRenderFns } from "./GeoPermission.vue?vue&type=template&id=0e3fadf5&scoped=true"
import script from "./GeoPermission.vue?vue&type=script&lang=ts"
export * from "./GeoPermission.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3fadf5",
  null
  
)

export default component.exports